export const menuSections = [
  {
    label: '日常事务',
    items: [
      { path: '/', title: '数据概览', icon: 'DataLine', auth: 'ui:dashboard:view' },
      {
        path: '/orders/new',
        title: '快速开单',
        icon: 'Position',
        className: 'highlight-item',
        // 开单入口：至少需要有开单权限
        auth: ['api:POST:/api/order/create', 'api:POST:/api/order/confirm']
      },
    ]
  },
  {
    label: '销售管理',
    items: [
      { path: '/orders', title: '销售单列表', icon: 'Tickets', auth: 'api:GET:/api/orders' },
      { path: '/online-orders', title: '线上接单', icon: 'ChatDotRound', className: 'menu-highlight', auth: 'api:GET:/api/online-orders' },
      { path: '/orders/return', title: '退货单列表', icon: 'RefreshLeft', auth: 'api:GET:/api/orders' },
      { path: '/orders/return/new', title: '新增退货单', icon: 'Search', auth: ['api:GET:/api/customers', 'api:GET:/api/orders', 'api:GET:/api/v1/order/returnable-items', 'api:POST:/api/v1/order/return'] },
      { path: '/orders/return/verify', title: '销售记录', icon: 'Search', auth: ['api:GET:/api/customers', 'api:GET:/api/returns/part-sales/search', 'api:GET:/api/orders/*'] },
    ]
  },
  {
    label: '进货管理',
    items: [
      { path: '/purchase/rma', title: '厂家退货列表', icon: 'Refresh', className: 'menu-highlight', auth: 'api:GET:/api/v1/rma/orders' },
      { path: '/purchase/rma/create', title: '厂家退货单', icon: 'Search', className: 'menu-highlight', auth: 'api:POST:/api/v1/rma/dispatch' },
      { path: '/purchase', title: '厂家进货列表', icon: 'Download', auth: 'api:GET:/api/purchase/orders' },
      { path: '/purchase/new', title: '厂家进货单', icon: 'Download', className: 'menu-highlight', auth: ['api:GET:/api/purchase/orders', 'api:POST:/api/purchase/orders'] },
      { path: '/suppliers', title: '供货商管理', icon: 'OfficeBuilding', auth: 'api:GET:/api/suppliers' },
      { path: '/aftersale', title: '售后工单', icon: 'Service', className: 'menu-highlight', auth: 'api:GET:/api/v1/aftersale/orders' },
    ]
  },
  {
    label: '库存管理',
    items: [
      { path: '/parts', title: '配件库存', icon: 'Box', auth: ['api:GET:/api/basic-parts', 'api:POST:/api/parts/search'] },
      { path: '/part-categories', title: '配件分类', icon: 'Box', auth: 'api:GET:/api/v1/parts/categories' },
      { path: '/warehouse', title: '仓库管理', icon: 'House', auth: 'api:GET:/api/warehouse' },
      { path: '/warehouse/bins', title: '仓位管理', icon: 'Grid', auth: 'api:GET:/api/v1/warehouse/bins' },
      { path: '/inventory/stocktake', title: '库存盘点', icon: 'TakeawayBox', auth: 'api:GET:/api/v1/inventory/stock' },
      { path: '/inventory/barcodes', title: '条码绑定台', icon: 'Link', auth: ['api:POST:/api/v1/barcode/scan', 'api:POST:/api/v1/barcode/learn'] },
    ]
  },
  {
    label: '客户与财务',
    items: [
      { path: '/customers', title: '客户管理', icon: 'User', auth: 'api:GET:/api/customers' },
      { path: '/finance/daily', title: '每日对账', icon: 'DataLine', auth: 'api:GET:/api/v1/finance/daily/summary' },
      { path: '/finance/monthly', title: '月结对账', icon: 'DataLine', auth: 'api:GET:/api/v1/finance/reconcile/batches' },
      { path: '/finance/ar', title: '客户往来账', icon: 'DataLine', auth: 'api:GET:/api/v1/finance/ar/balances' },
      { path: '/finance/profit', title: '利润分析', icon: 'DataLine', className: 'menu-highlight', auth: 'api:GET:/api/v1/finance/dashboard/summary' },
      { path: '/finance/legacy', title: '欠款补录', icon: 'DataLine', auth: 'api:POST:/api/v1/finance/balance/initialize' },
    ]
  },
  {
    label: '员工管理',
    items: [
      { path: '/staff/operators', title: '员工管理', icon: 'User', auth: 'api:GET:/api/v1/staff/operators' },
      { path: '/attendance', title: '缺勤记录', icon: 'DataLine', auth: 'api:GET:/api/v1/attendance/absences' },
      { path: '/delivery', title: '配送管理', icon: 'Van', auth: 'api:GET:/api/v1/delivery/routes' },
      { path: '/delivery/routes', title: '配送路线', icon: 'Van', auth: 'api:GET:/api/v1/data-governance/delivery-routes' },
    ]
  },
  {
    label: '数据治理',
    items: [
      { path: '/vehicle-models', title: '车型工作台', icon: 'Van', auth: 'api:GET:/api/v1/data-governance/vehicle-models', className: 'menu-highlight' },
    ]
  },
  {
    label: '系统管理',
    items: [
      { path: '/settings', title: '系统设置', icon: 'Setting', roles: ['admin'], auth: 'api:GET:/api/v1/system/backup/latest' },
      { path: '/settings/users', title: '用户权限', icon: 'User', roles: ['admin'], auth: 'api:GET:/api/v1/admin/users' },
      { path: '/settings/roles', title: '角色权限', icon: 'Setting', roles: ['admin'], auth: 'api:GET:/api/v1/admin/perms' },
      { path: '/settings/mini-wechat', title: '小程序审核', icon: 'UserFilled', roles: ['admin'], auth: 'api:GET:/api/v1/admin/mini/wechat/applications' },
      { path: '/fitment', title: '智配黑榜', icon: 'DataLine', className: 'menu-highlight', auth: 'api:GET:/api/fitment/insights' },
      { path: '/fitment/shadow', title: '适配记录', icon: 'DataLine', auth: 'api:GET:/api/fitment/insights' },
      { path: '/fitment/categories', title: '分类治理', icon: 'DataLine', auth: 'api:POST:/api/v1/categories/reparent' },
    ]
  },
]

const hiddenRoutesMap = {
  '/orders/return/new': '新增退货单',
  '/orders/return/verify': '销售记录',
  '/purchase/rma/create': '厂家退货单',
  '/purchase/new': '厂家进货单',
  '/settings/mini-wechat': '小程序审核',
}

function flattenItems(items, pathMap) {
  items.forEach((item) => {
    if (item.path && item.title) {
      pathMap[item.path] = item.title
    }
    if (Array.isArray(item.children) && item.children.length > 0) {
      flattenItems(item.children, pathMap)
    }
  })
}

export function getBreadcrumbMap() {
  const pathMap = {}
  menuSections.forEach((section) => {
    flattenItems(section.items || [], pathMap)
  })
  return { ...pathMap, ...hiddenRoutesMap }
}
